import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

export const postEmpreendimentoRevendaListar = async ({
  status,
  nome,
  registros,
  pagina,
  authToken,
}: {
  status: boolean;
  nome: string;
  registros: number;
  pagina: number;
  authToken: string;
}): Promise<any> => {
  const url = "api/RevendaEmpreendimento/ListarPorFiltro";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(
    url,
    { status, nome, registros, pagina },
    config
  );
  return response?.data;
};
